import React from 'react'
import './About-banner.css'
import { Link } from 'react-router-dom'

const About_banner = () => {
  return (
    <>
      <section className='about-banner-sec'>
        <div className='container'>
          <div className='banner-div'>
            <img className='abt-banner' src={process.env.PUBLIC_URL + '/assets/images/about_us/banner.png'} alt="about-banner" />

            {/* <div className='downloadbtnsec'>
              <Link to="#"><img src={process.env.PUBLIC_URL + '/assets/images/icons/googleplay.png'} alt="google-play" /></Link>
              <Link to="#"><img src={process.env.PUBLIC_URL + '/assets/images/icons/appstore.png'} alt="google-play" /></Link>
            </div> */}
          </div>
        </div>
      </section>
    </>
  )
}

export default About_banner